export const config = {
  title: "Bananas Grooming | Professional Grooming Services in Puerto Rico",
  meta: {
    description:
      "Bananas Grooming provides top-quality pet grooming services in Carolina, Puerto Rico, offering professional and caring grooming experiences for your beloved pets.",
    keywords: [
      'Pet Grooming Puerto Rico',
      'Bananas Grooming',
      'Dog Grooming',
      'Cat Grooming',
      'Pet Spa Services',
      'Bath & Haircut',
      'Nail Trimming',
      'Pet Care',
      'Grooming Salon',
      'Carolina PR Pet Grooming'
    ],
    author: "Bananas Grooming",
    canonicalUrl: 'https://www.facebook.com/p/Bananas-grooming-100083033603527/',
  },
  sections: {
    header: {
      businessName: "Bananas Grooming",
    },
    sectionB: {
      heroTitle: "Bananas Grooming",
      heroSubtitle: 'Pampering Pets with Love & Care in Puerto Rico',
      learnAboutText: 'Discover Our Grooming Services',
      phoneNumber: '9395391600',
      phoneLabel: '(939) 539-1600',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1277453154/photo/golden-retriever-dog-in-a-grooming-salon-is-taking-a-shower.jpg?s=612x612&w=0&k=20&c=J2vXxWLGC559xEgSt3OyBahZVs91CALA0tyI7FR_A98=",
      cardData: [
        {
          title: 'Caring & Professional Staff',
          description: 'Our experienced groomers ensure a stress-free and comfortable experience for your pet.',
        },
        {
          title: 'Comprehensive Grooming Services',
          description: 'From baths to haircuts, nail trimming, and styling, we cater to all your pet’s grooming needs.',
        },
        {
          title: 'Safe & Friendly Environment',
          description: 'A clean, friendly, and safe grooming salon to keep your pet happy and healthy.',
        },
      ],
      description:
        "At Bananas Grooming, we specialize in providing high-quality pet grooming services, including haircuts, nail trimming, bathing, and styling for dogs and cats. Our team is committed to making your pet look and feel their best.",
    },
    sectionC: {
      servicesTitle: 'Our Grooming Services',
      servicesDescription:
        "Explore the wide range of grooming services we offer to keep your pets looking and feeling great.",
      cards: [
        {
          title: 'Full Grooming Package',
          description:
            'A complete package including bath, haircut, nail trimming, and ear cleaning.',
          imageSrc: 'https://media.istockphoto.com/id/639024502/photo/time-for-a-haircut.jpg?s=612x612&w=0&k=20&c=ffFNRH1Ix3mxoZPR61QEpCEZprLESAaLYij2Yurr8Hs=',
          imageAlt: 'Full Grooming Package',
        },
        {
          title: 'Bath & Blow Dry',
          description:
            'A gentle bath with premium pet-safe shampoos followed by a relaxing blow-dry.',
          imageSrc: 'https://media.istockphoto.com/id/2192960820/photo/australian-shepherd-red-merle-and-pet-groomer.jpg?s=612x612&w=0&k=20&c=FStkSsWW4aazMcZAiG9c_IJlyr8hM1lgZZlpaY-Jmds=',
          imageAlt: 'Bath & Blow Dry',
        },
        {
          title: 'Nail Trimming & Paw Care',
          description:
            'Keeping your pet’s paws clean and nails trimmed for their comfort and hygiene.',
          imageSrc: 'https://media.istockphoto.com/id/2194515915/photo/close-up-of-girls-hand-trims-long-claws-on-grey-rabbits-hind-leg-with-special-pet-grooming.jpg?s=612x612&w=0&k=20&c=J6M9w4uvn-WrEmE_SZcodjSg6nUWri8we-QF1AiMtRc=',
          imageAlt: 'Nail Trimming & Paw Care',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Deshedding Treatment',
        'Flea & Tick Bath',
        'Ear Cleaning',
        'Teeth Brushing',
        'Custom Styling',
        'Puppy & Kitten Grooming',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/2189116029/photo/dog-grooming-concept-cuts-and-shaves-cat-in-pet-beauty-salon-services-cleaning-dog-nails-dog.jpg?s=612x612&w=0&k=20&c=tR8sH_-RNu0MTuM4R0y1U7A45Y95QWeHDO20e9K1lbA=',
        alt: "Bananas Grooming Team",
      },
      aboutText: [
        "Bananas Grooming is a locally owned and operated pet grooming business in Carolina, Puerto Rico, dedicated to providing the best grooming care for your pets.",
        "With a passion for pet care and years of experience, our team ensures that every pet gets personalized attention and a comfortable grooming experience.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Bananas Grooming Logo",
      businessName: "Bananas Grooming",
      contact: {
        phone: '9395391600',
        phoneLabel: '(939) 539-1600',
        email: 'bananasgrooming@gmail.com',
        website: 'https://www.facebook.com/p/Bananas-grooming-100083033603527/',
        address: 'Beautiful Park Street, 5887, Carolina, Puerto Rico',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/p/Bananas-grooming-100083033603527/',
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: 'Beautiful Park Street, 5887, Carolina, Puerto Rico',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3141.123456789012!2d-66.0231234!3d18.3952345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c02b1234567890b%3A0x1234567890abcdef!2sCarolina%2C%20Puerto%20Rico!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
